<template>
  <div class="flex flex-col w-full">
    <div class="leading-7 text-sm text-gray-600">
      <slot name="title" />
    </div>
    <div class="p-3 rounded-md bg-white">
      <div class="flex flex-wrap">
        <div
          v-for="preset in choices"
          :key="preset"
          class="w-1/2 px-1 mb-2"
          @click="setThoughtPreset(preset)"
        >
          <div
            class="px-1 py-1 border text-center rounded-full transition-colors duration-100 text-sm md:text-base tracking-tight"
            :class="getDynamicCss(preset)"
          >
            {{ preset }}
          </div>
        </div>
        <div class="w-1/2 px-1 mb-2" @click="toggleWritingMode">
          <div
            class="px-1 py-1 border text-center rounded-full transition-colors duration-100 text-sm md:text-base tracking-tight"
            :class="getDynamicCss(choiceForManual)"
            @change="onManualInputChange"
          >
            {{ choiceForManual }}
          </div>
        </div>
      </div>
      <div v-if="isManual">
        <m-text-field
          :name="name"
          type="text"
          placeholder=""
          :value="value"
          :invalid="isManual && !value"
          :invalid-message="invalidMessage"
          class="mt-2 rounded-md"
          :class="entered && isManual && !value ? '' : 'border border-gray-400'"
          :entered="entered"
          @input="onManualInputChange"
          @enter="entered = true"
        />
        <div className="text-xs text-gray-500 mt-2">
          ※ ながいもじは、・・・でまとめられるよ
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MTextField from "@/components/form/MTextField.vue";

@Options({
  components: {
    MTextField
  },
  emits: ["input", "enter", "change"],
  props: {
    choices: Array,
    placeholder: String,
    value: String,
    invalidMessage: String,
    choiceForManual: String
  }
})
export default class MTextSelector extends Vue {
  name = "textSelector";
  placeholder = "";
  value = "";
  invalid = false;
  invalidMessage = "入力（にゅうりょく）してください";
  choices: string[] = [];
  choiceForManual = "じぶんでかく";
  isManual = false;
  entered = false;

  setThoughtPreset(preset: string) {
    if (this.isManual) {
      this.isManual = false;
    }
    this.$emit("change", preset);
  }

  toggleWritingMode() {
    this.isManual = !this.isManual;
    if (this.isManual) {
      this.entered = false;
    }
    this.$emit("change", "");
  }

  getDynamicCss(preset: string) {
    if (
      (preset === this.choiceForManual && this.isManual) ||
      (preset !== this.choiceForManual &&
        this.value === preset &&
        !this.isManual)
    ) {
      return {
        "border-primary-500": true,
        "bg-primary-500": true,
        "text-white": true,
        "cursor-pointer": true
      };
    } else {
      return {
        "border-gray-400": true,
        "text-gray-500": true,
        "cursor-pointer": true
      };
    }
  }

  onManualInputChange(v: string) {
    this.$emit("change", v);
  }

  onBlur() {
    this.$emit("enter");
  }
}
</script>
